var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoorBell({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 60,
    viewBox: "0 0 32 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.95591 2.32671C4.31369 2.32671 2.16487 4.46879 2.16487 7.10273V52.937C2.16487 55.5696 4.31369 57.7124 6.95591 57.7124H25.485C28.1266 57.7124 30.2747 55.5696 30.2747 52.937V7.10273C30.2747 4.46879 28.1266 2.32671 25.485 2.32671H6.95591ZM25.485 59.4275H6.95591C3.36515 59.4275 0.444336 56.5165 0.444336 52.937V7.10273C0.444336 3.52256 3.36515 0.611572 6.95591 0.611572H25.485C29.0751 0.611572 31.9959 3.52256 31.9959 7.10273V52.937C31.9959 56.5165 29.0751 59.4275 25.485 59.4275V59.4275Z",
    fill: "#F57F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2205 34.5506C11.9262 34.5506 8.43147 38.0337 8.43147 42.3152C8.43147 46.5967 11.9262 50.0785 16.2205 50.0785C20.5148 50.0785 24.0096 46.5967 24.0096 42.3152C24.0096 38.0337 20.5148 34.5506 16.2205 34.5506M16.2205 51.7943C10.9764 51.7943 6.71094 47.5423 6.71094 42.3152C6.71094 37.0882 10.9764 32.8354 16.2205 32.8354C21.464 32.8354 25.7301 37.0882 25.7301 42.3152C25.7301 47.5423 21.464 51.7943 16.2205 51.7943",
    fill: "#F57F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2202 12.1731C15.1924 12.1731 14.356 13.0063 14.356 14.0322C14.356 15.0567 15.1924 15.8898 16.2202 15.8898C17.2479 15.8898 18.0843 15.0567 18.0843 14.0322C18.0843 13.0063 17.2479 12.1731 16.2202 12.1731M16.2202 17.605C14.2432 17.605 12.6348 16.0029 12.6348 14.0322C12.6348 12.0607 14.2432 10.458 16.2202 10.458C18.1971 10.458 19.8056 12.0607 19.8056 14.0322C19.8056 16.0029 18.1971 17.605 16.2202 17.605",
    fill: "#F57F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8692 25.8184H7.57123C7.08991 25.8184 6.69922 25.4289 6.69922 24.9484C6.69922 24.468 7.08991 24.0785 7.57123 24.0785H24.8692C25.3512 24.0785 25.7419 24.468 25.7419 24.9484C25.7419 25.4289 25.3512 25.8184 24.8692 25.8184",
    fill: "#F57F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorBell);
export default __webpack_public_path__ + "static/media/DoorBell.d382ffeac5f27ac5579543ecf6e8deb4.svg";
export { ForwardRef as ReactComponent };